<!-- eslint-disable no-restricted-syntax -->
<template>
  <d-form :validated="hasErrors">
    <d-form-row class="form-group">
      <d-col cols="8">
        <label>Nome:</label>
        <d-form-input
          type="text"
          v-model="model.name"
          :state="hasErrorFiled('name')"
        />
        <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
      </d-col>
      <d-checkbox
        toggle
        v-model="model.settings.enableGroupedGeneration"
        :disabled="model.id && groupsOfWord.length === 1"
        class="custom-toggle-sm"
      >
        Gerar vários jogos de uma vez

        <i
          id="tooltip-enable_grouped_generation"
          class="fas fa-info-circle text-muted"
          style="cursor: pointer"
        />
        <d-tooltip target="tooltip-enable_grouped_generation" placement="top">
          Permite criar vários jogos de caça-palavras ao mesmo tempo.
        </d-tooltip>
      </d-checkbox>
    </d-form-row>
    <d-form-row class="form-group mb-2 pt-2">
      <d-col cols="12">
        <d-card class="mb-1 shadow-none border border-1 rounded" key="0">
          <d-card-header
            class="p-3 d-flex justify-content-between w-100 rounded"
            role="tab"
            @click.native="toggleAccordion(0)"
          >
            <span class="d-flex align-items-center justify-content-center mr-2">
              <i class="fas fa-chevron-right" :class="{ rotated: isOpen(0) }" />
            </span>
            <copy-text-title title="Configurações padrão" />
          </d-card-header>
          <d-collapse
            :id="`accordionItem${0}`"
            :visible="isOpen(0)"
            class="px-4 pb-4"
          >
            <d-form-row>
              <d-col cols="12" md="4">
                <d-col
                  class="d-flex flex-wrap px-1 justify-content-between mb-1"
                >
                  <label for="feWordsPerGroup" class="w-55">
                    Tamanho linhas:
                  </label>
                  <d-form-input
                    type="number"
                    id="feWordsPerGroup"
                    min="1"
                    class="w-50"
                    placeholder="Quantidade de linhas"
                    v-model.number="model.rows"
                  />
                </d-col>
                <d-col class="d-flex flex-wrap px-1 justify-content-between">
                  <label for="feWordsPerGroup" class="w-55">
                      Tamanho colunas:
                  </label>
                  <d-form-input
                    type="number"
                    id="feWordsPerGroup"
                    min="1"
                    class="w-50"
                    placeholder="Quantidade de colunas"
                    v-model.number="model.columns"
                  />
                </d-col>
              </d-col>

              <d-col cols="6" md="4" class="mb-2">
                <label>Posicionamento das palavras</label>
                <d-checkbox
                  class="custom-toggle-sm"
                  v-for="(enabled, position) in model.settings.positions"
                  :key="position"
                  v-model="model.settings.positions[position]"
                >
                  {{ LABELS_POSITIONS[position] }}
                </d-checkbox>
                <CheckboxGroup
                  v-model="model.settings.invertedPositions"
                  label="Invertida"
                  :labelsChildren="LABELS_POSITIONS"
                />
              </d-col>
              <d-col cols="12" md="4" class="form-group">
                <distribution-by-percentage
                  v-model="model.settings.percentages"
                  :enabledByDefault.sync="
                    model.settings.enablePercentageDistribution
                  "
                  :enabled-directions="enabledDirections"
                />
                <d-checkbox
                  toggle
                  v-model="model.settings.enableSubWord"
                  class="custom-toggle-sm"
                >
                  Evitar palavra e sub-palavra
                </d-checkbox>
                <d-checkbox
                  toggle
                  v-model="model.settings.showGrid"
                  class="custom-toggle-sm"
                >
                  Mostrar Grade
                </d-checkbox>
                <d-checkbox
                  toggle
                  v-model="model.settings.showWordPositions"
                  class="custom-toggle-sm"
                >
                  Destacar Palavras
                </d-checkbox>
                <div v-if="model.settings.showWordPositions" class="mt-2 ml-5">
                  <d-radio
                    v-model="model.settings.highlightMode"
                    name="highlight-mode"
                    value="color"
                    class="fs-6 text-muted"
                  >
                    Cor de Fundo
                  </d-radio>

                  <d-radio
                    v-model="model.settings.highlightMode"
                    name="highlight-mode"
                    value="border"
                    class="fs-6 text-muted"
                  >
                    Borda Suave
                  </d-radio>
                </div>
              </d-col>
            </d-form-row>
          </d-collapse>
        </d-card>
      </d-col>
    </d-form-row>
    <d-form-row class="form-group" v-if="groupsOfWord.length !== 1">
      <d-col cols="12" md="3">
        <label class="d-flex align-items-end mb-0">
          Lista de Palavras (uma por linha)
        </label>
        <textarea v-model="localWordList" class="form-control word-list" />
        <div
          class="d-flex justify-content-end align-items-center"
          v-if="localWordList.length"
        >
          <span>Total de palavras: </span>
          <span class="custom-font">{{ totalWords }}</span>
        </div>
      </d-col>

      <d-col cols="12" md="4">
        <d-button
          type="button"
          class="btn btn-success mr-1"
          @click.stop="generateMultipleHuntingWords"
          :disabled="loading || isButtonDisabled"
        >
          <i class="fas fa-sync"></i>
          <span class="d-none d-lg-inline ml-1"> Gerar</span>
        </d-button>
      </d-col>
    </d-form-row>
    <d-form-row class="px-1 mb-1 d-flex justify-content-end" v-if="games.length > 1">
      <d-button
        type="button"
        class="btn-outline-primary"
        @click.prevent="toggleAllAccordions"
      >
        {{ areAllOpen ? 'Fechar todos' : 'Abrir todos' }}
      </d-button>
    </d-form-row>
    <d-form-row class="form-group mt-3 mb-1">
      <d-col cols="12">
        <d-card class="mb-1" v-for="(game, index) in games" :key="game.id">
          <d-card-header
            class="p-3 d-flex justify-content-between w-100 rounded"
            role="tab"
            @click.native="toggleAccordion(index + 1)"
          >
            <span
              class="d-flex align-items-center justify-content-center mr-2"
              v-if="games.length > 1"
            >
              <i
                class="fas fa-chevron-right"
                :class="{ rotated: isOpen(index + 1) }"
              />
            </span>
            <copy-text-title
              :title="games.length === 1 ? '' : `Jogo ${index + 1}`"
            >
              <d-button
                type="button"
                class="btn btn-outline-dark mr-1"
                @click.stop="generateHuntingWords(game, groupsOfWord[index])"
                :disabled="loading || isButtonDisabled"
              >
                <i class="fas fa-sync"></i>
                <span class="d-none d-lg-inline ml-1"> Gerar novamente</span>
              </d-button>
            </copy-text-title>
          </d-card-header>
          <d-collapse
            :id="`accordionItem${index + 1}`"
            :visible="isOpen(index + 1) || games.length === 1"
            :show-icon="false"
            class="p-4"
          >
            <d-form-row class="form-group mb-2">
              <d-col cols="12" md="6">
                <label class="d-flex align-items-end mb-0">
                  Lista de Palavras (uma por linha)
                </label>
              </d-col>
            </d-form-row>
            <d-form-row class="form-group">
              <d-col cols="12" md="2">
                <textarea
                  v-model="groupsOfWord[index]"
                  :disabled="groupsOfWord.length !== 1"
                  class="form-control word-list"
                />
              </d-col>
              <d-col cols="12" md="10">
                <div
                  v-if="loading"
                  class="d-flex w-100 justify-content-center align-items-center bg-black"
                >
                  <div class="spinner-border text-primary" />
                </div>

                <template v-else>
                  <GameGrid
                    :rows="model.rows"
                    :columns="model.columns"
                    :table="game.table"
                    :highlightedWords="game.settings.placedWords"
                    :showGrid="model.settings.showGrid"
                    :showWordPositions="model.settings.showWordPositions"
                    :highlightMode="model.settings.highlightMode"
                  />

                  <div
                    class="w-100 text-center my-2"
                    v-if="!loading"
                  >
                    <GameStatusAndPopover
                      :game-settings="game.settings"
                      :index="index"
                    />
                  </div>
                </template>
              </d-col>
            </d-form-row>
          </d-collapse>
        </d-card>
      </d-col>
    </d-form-row>
  </d-form>
</template>

<script>
import { mapActions } from 'vuex';

import {
  cloneDeep,
  getUnplacedWords,
  getPlacedWords,
  prepareWords,
  removeDuplicateLines,
  removeEmpty,
  toWordString,
  getLength,
  getWordList,
  normalizeWord,
} from '_utils';
import Events from '_utils/events';
import mixin from '_common/mixins/ValidateForm';
import formatErrors from '_common/mixins/FormatErrors';
import PuzzleTable from '_common/mixins/PuzzleTable';
import CheckboxGroup from '_shared/CheckboxGroup.vue';
import PuzzleService from '_services/rest/modules/puzzle';
import WordHuntEngine from '_utils/wordHunt/WordHuntEngine';
import {
  MODEL,
  LABELS_POSITIONS,
  _LOAD_MODEL_,
  DEFAULT_SETTINGS,
} from './HuntingWordsModel';
import DistributionByPercentage from './DistributionByPercentage.vue';
import GameGrid from './GameGrid.vue';
import CopyTextTitle from './CopyTextTitle.vue';
import GameStatusAndPopover from './GameStatusAndPopover.vue';

export default {
  name: 'hunting-words-form',
  mixins: [mixin, formatErrors, PuzzleTable],
  components: {
    CheckboxGroup,
    DistributionByPercentage,
    GameGrid,
    CopyTextTitle,
    GameStatusAndPopover,
  },
  computed: {
    enabledDirections() {
      const all = {
        ...this.model.settings.positions,
        ...this.model.settings.invertedPositions,
      };

      return Object.fromEntries(
        Object.entries(all).filter(([_, enabled]) => enabled),
      );
    },
    isButtonDisabled() {
      const noDirectionsEnabled =
        Object.keys(this.enabledDirections).length === 0;
      const noWordsInList = this.localWordList.length === 0;

      return noDirectionsEnabled || noWordsInList;
    },
    areAllOpen() {
      const total = this.model?.children?.length || 0;
      const expectedOpen = Array.from({ length: total - 1 }, (_, i) => i + 1);
      return expectedOpen.every(index => this.openAccordions.includes(index));
    },
    totalWords() {
      const formattedWordsList = removeDuplicateLines(this.localWordList);
      return removeEmpty(formattedWordsList).length;
    },
  },
  data() {
    return {
      model: cloneDeep(MODEL),
      games: [],
      groupsOfWord: [],
      openAccordions: [0],
      localWordList: '',
      quill: null,
      LABELS_POSITIONS,
      loading: false,
      errors: {
        name: { required: false },
      },
    };
  },
  methods: {
    ...mapActions(['activeAlert', 'setHuntingWords', 'setHasChanges']),
    getPlacedWords,
    getUnplacedWords,
    getLength,
    setQuill(quill) {
      this.quill = quill;
    },
    createEmptyGames(count) {
      return Array.from({ length: count }, () => cloneDeep(MODEL));
    },
    adjustGamesList(currentGames, targetLength) {
      const currentLength = currentGames?.length || 0;

      if (currentLength === targetLength) return currentGames;

      if (currentLength < targetLength) {
        return [
          ...(currentGames || []),
          ...this.createEmptyGames(targetLength - currentLength),
        ];
      }

      return currentGames.slice(0, targetLength);
    },
    generateMultipleHuntingWords() {
      const groups = this.model.settings.enableGroupedGeneration
        ? this.parseGroupsFromText(this.localWordList)
        : this.prepareGroupedWords();

      this.groupsOfWord = groups;

      this.games = this.model.id
        ? this.adjustGamesList(this.games, groups.length)
        : this.createEmptyGames(groups.length);

      groups.forEach((words, index) => {
        const engine = new WordHuntEngine(this.model, {
          activeAlert: this.activeAlert,
        });

        const list = prepareWords(
          words,
          this.model.settings.enableSubWord,
          this.games[index],
        );

        this.games[index].settings.placedWords = [];
        engine.generate(this.games[index], list, index + 1);

        this.syncSortedWordsWithGame(
          words,
          this.games[index],
          index,
        );
      });

      this.openAccordions = [0, ...groups.map((_, i) => i + 1)];
      this.setHasChanges(true);
    },
    generateHuntingWords(game, words) {
      this.loading = true;

      const wordsList = prepareWords(
        words,
        this.model.settings.enableSubWord,
        game,
      );

      const engine = new WordHuntEngine(this.model, { activeAlert: this.activeAlert });

      game.settings.placedWords = [];

      engine.generate(game, wordsList);

      const index = this.games.indexOf(game);

      if (index !== -1) {
        this.syncSortedWordsWithGame(words, game, index);
      }

      this.setHasChanges(true);
      this.loading = false;
    },
    syncSortedWordsWithGame(words, game, index) {
      const wordsListOriginal = getWordList(words).map(word => normalizeWord(word));
      const sortedArray = [...wordsListOriginal].sort((a, b) => a.localeCompare(b));
      const sortedText = sortedArray.join('\n');

      this.$set(this.groupsOfWord, index, sortedText);
      game.settings.wordsList = sortedArray;
    },
    normalizeTable(model) {
      const hasTable = Array.isArray(model.table) && model.table.length > 0;

      if (!hasTable) return null;

      return model.id
        ? model.table.map(item => ({ ...item, updated: true }))
        : model.table;
    },
    prepareGroupedWords() {
      const wordsList = prepareWords(this.localWordList, false, this.model);
      this.model.settings.wordsList = this.localWordList;

      const groups = [];

      if (this.model.settings.enableGroupedGeneration) {
        const rawGroups = this.parseGroupsFromText(this.localWordList);
        rawGroups.forEach(g => {
          const prepared = prepareWords(g, false, this.model);
          groups.push(prepared.join('\n'));
        });
      } else {
        groups.push(wordsList.join('\n'));
      }

      return groups;
    },
    preparePuzzleModel() {
      let table = this.normalizeTable(this.model);
      let children = [];
      let placedWords = null;
      let wordsList = null;

      if (this.model.settings.enableGroupedGeneration) {
        children = this.games;
        wordsList = this.groupsOfWord
          .map(g => g.split('\n').filter(w => w.trim() !== ''))
          .flat();
      } else {
        const first = this.games[0];
        table = first?.table;
        placedWords = first?.settings?.placedWords;
        wordsList = first?.settings?.wordsList;
      }

      return {
        ...this.model,
        table,
        slug: `${this.model.name.replace(/\s+/g, '-')}-caca-palavras`,
        settings: {
          ...this.model.settings,
          placedWords,
          wordsList,
        },
        children,
      };
    },
    save() {
      if (this.checkForm()) {
        const puzzle = this.preparePuzzleModel();
        this.setHuntingWords(puzzle);

        PuzzleService.save(puzzle)
          .then(response => {
            this.activeAlert({ message: response.message, theme: 'success' });
            if (this.$route.name === 'admin-hunting-words-new') {
              this.$router.push({
                name: 'admin-hunting-words-edit',
                params: { puzzleId: response.id },
              });
            }
            this.model = response;
            this.setHasChanges(false);
          })
          .catch(error => {
            const errors = this.formatErrors(error.data);
            this.activeAlert({ message: errors, theme: 'danger' });
          });
      }
    },
    toggleAccordion(index) {
      if (this.openAccordions.includes(index)) {
        this.openAccordions = this.openAccordions.filter(i => i !== index);
      } else {
        this.openAccordions.push(index);
      }
    },
    toggleAllAccordions() {
      const childCount = this.model?.children?.length || 0;
      const childIndexes = Array.from({ length: childCount }, (_, i) => i + 1);

      if (this.areAllOpen) {
        this.openAccordions = this.openAccordions.filter(index => index === 0);
      } else {
        const keep = this.openAccordions.includes(0) ? [0] : [];
        this.openAccordions = [...keep, ...childIndexes];
      }
    },
    isOpen(index) {
      return this.openAccordions.includes(index);
    },
    parseGroupsFromText(text) {
      return text
        .split(/\n\s*\n/)
        .map(g => g.trim())
        .filter(g => g.length > 0);
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_, model => {
      const settings = model.settings || { ...DEFAULT_SETTINGS };
      this.localWordList = toWordString(model.settings.wordsList);
      this.games = [];

      this.model = {
        ...model,
        settings,
      };

      if (model.settings.enableGroupedGeneration && model.children?.length) {
        this.localWordList = model.children
          .map(c => c.settings.wordsList.join('\n'))
          .join('\n\n');

        this.games = [];
        this.groupsOfWord = [];
        this.openAccordions = [0];

        model.children.forEach((game, index) => {
          this.games.push(cloneDeep(game));
          this.groupsOfWord.push(game.settings.wordsList.join('\n'));
          this.openAccordions.push(index + 1);
        });
      } else {
        this.localWordList = toWordString(model.settings.wordsList);
        this.games = [cloneDeep(model)];
        this.groupsOfWord = [this.localWordList];
      }
    });
  },
  destroyed() {
    this.games = [];
    this.groupsOfWord = [];
    Events.$off(_LOAD_MODEL_);
  },
};
</script>

<style lang="scss" scoped>
.word-list {
  min-height: 200px;
}
.text-area {
  background-color: transparent;
  resize: none;
  padding-left: 0px;
  min-height: 200px;
  margin-top: 8px;
  height: auto;
}

.rotated {
  transform: rotate(90deg);
  transition: transform 0.3s ease;
}

.custom-font {
  font-weight: 700;
  margin-left: 8px;
}
</style>
